import { useSelector } from 'react-redux';
import { getIsLoadingPresets } from '../../selectors/presetsSelectors';
import { getSaveRequestStatus } from '../../selectors/themeSettingsMetaSelectors';
import { PENDING } from '../../constants/RequestStatusTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import PresetTile from './PresetTile';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `theme-previewer.themePresets.${key}`;
const ActiveThemePresetCard = ({
  activeThemePresetId,
  hasUserThemeOverrides,
  onBrowsePresetsClick,
  themePath
}) => {
  const isLoadingPresets = useSelector(getIsLoadingPresets);
  const saveRequestStatus = useSelector(getSaveRequestStatus);
  if (isLoadingPresets) {
    return /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small",
        grow: true
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(PresetTile, {
      isLoading: saveRequestStatus === PENDING,
      ignoreUserThemeOverrides: !hasUserThemeOverrides,
      onClick: onBrowsePresetsClick,
      presetId: activeThemePresetId,
      themePath: themePath
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "browse-presets-button",
      onClick: onBrowsePresetsClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('browsePresets')
      })
    })]
  });
};
export default ActiveThemePresetCard;